'use client'
import { useEffect, useState } from 'react'
import s from './Contact.module.scss'
import { motion, AnimatePresence } from 'framer-motion'
import { Image } from '@/types/common/ImageData'
import { PortableText } from '@portabletext/react'
import { portableBlockComponents } from '@/utils/portableText'
import Link from 'next/link'

interface ContactProps {
    data: any;
}

export default function ContactComponent({
    data
}: ContactProps) {

    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleDescription = (index: number) => {
        setOpenIndex(prevIndex => (prevIndex === index ? null : index));
    };


    return (
        <div className={s.contact}>
            <div className={s.topContent}>
                {data.content && data.content.map((content: any, index: number) => {
                    return (
                        <div key={index} className={s.content}>
                            {content.content &&
                                <PortableText
                                    value={content.content}
                                    components={portableBlockComponents(content.content)}
                                />
                            }
                        </div>
                    )
                })}
            </div>
            <div className={s.topCareers}>
                {data.topText &&
                    <PortableText
                        value={data.topText}
                        components={portableBlockComponents(data.topText)}
                    />
                }
            </div>
            <div className={s.careers}>
                <div className={s.top}>
                    <p>POSITION</p>
                    <p className={s.descriptionTitle}>DESCRIPTION</p>
                </div>
                {data.careers && data.careers.map((career: any, index: number) => {
                    return (
                        <div key={index} className={s.career} onClick={() => toggleDescription(index)}>
                            <div className={s.title}>
                                <p>{career.title}</p>
                            </div>
                            <div className={s.content}>
                                <div className={s.subtitle}>
                                    <p>{career.subtitle}</p>
                                </div>
                                <AnimatePresence>
                                    {openIndex === index && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.3, ease: "easeInOut" }}
                                            className={s.description}
                                        >
                                            {career.body && (
                                                <PortableText
                                                    value={career.body}
                                                    components={portableBlockComponents(career.body)}
                                                />
                                            )}
                                            {career.link && (
                                                <Link href={career.link} target={"_blank"}>
                                                    <button className={s.link}>
                                                        APPLY NOW

                                                    </button></Link>
                                            )}
                                        </motion.div>
                                    )}
                                </AnimatePresence>

                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );

}